import { createContext, use } from "react";
import { M365PulseFlyoutProps } from "./M365PulseFlyout.types";

export const FlyoutContext = createContext<boolean>(false);

export const useInFlyout = (): boolean => use(FlyoutContext);

type FlyoutWrapperContextProps = Partial<Omit<M365PulseFlyoutProps, "children">> & {
    isOpen?: boolean;
    openFlyout?: () => void;
    closeFlyout?: () => void;
};

export const FlyoutWrapperContext = createContext<FlyoutWrapperContextProps>({});
